// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1KbH-","col":"styles_col__21tcm"};